export const Z_MIN = -4;
export const Z_MAX = 4;

export const ANIMATION_DURATION = 500; // milliseconds
export const SAMPLE_COUNT = 64;
export const DECIMAL_PRECISION = 2;

export const CSV_FILENAME = "effectsize.science.csv";

export const COLORS = {
	a: "#55a3ed",
	b: "#28ef53"
};

export const HATCH = true;
